export const TRIAL_LINK_CLAIM_PARAM = "trial_link_claim";

export function buildPathWithTrialLinkClaim(path: string, token?: string | null) {
  if (!token) {
    return path;
  }

  const params = new URLSearchParams();
  params.set(TRIAL_LINK_CLAIM_PARAM, token);
  return `${path}?${params.toString()}`;
}
